export default class Search {
    /*
     * Fires first
     */
    constructor() {

		this.page = 1;
		this.max_page = jQuery('.js-max-pages').text();
		this.order = '';

        // Add events
        this.addEvents();
    }

    /*
     * Add events
     */
    addEvents() {

        $('.js-next-page').on('click', (e) => {
            e.preventDefault();
			
			this.page = this.page > 1 ? this.page - 1 : 1;
            this.updatePosts(1);
        });

		$('.js-prev-page').on('click', (e) => {
            e.preventDefault();
			
			this.page = this.max_page >= this.page ? this.page + 1 : 1;
            this.updatePosts(-1);
        });

		$('.js-sort-by').on('change', (e) => {
            e.preventDefault();
			this.order = e.currentTarget.value;
			console.log(this.order);
        });

        $('#search_filters').submit( (e) => {
            e.preventDefault();

            this.updatePosts(0);

			let postType = '';

            postType = $('#post_types').val();

            let url = new URL(window.location.href + '?type=post');
            let search_params = url.searchParams;

            // new value of "id" is set to "101"
            search_params.set('type', postType);

            // change the search property of the main url
            url.search = search_params.toString();

            // the new url string
            let new_url = url.toString();

            history.pushState({
                id: 'type',
                source: 'web',
            }, 'Type', new_url );
        });

        $(document).on('change', '.js-sort-by' , e => {
            e.preventDefault();

            this.updatePosts(0);
        });
    }

    updatePosts(direction, reset = false) {
	
		var new_page = ajaxObject.current_page + direction;

		// Check we can change page
		if (new_page <= 0 || new_page > ajaxObject.max_page && ajaxObject.max_page != 0 ) return;

		if ( reset ) {
			ajaxObject.current_page = 1;
			direction = 0;
		}

        $.ajax({
			url : ajaxObject.ajax_url, // AJAX handler
			dataType: 'json',
			data : {
				'action': 'changepage', // the parameter for admin-ajax.php
				'direction': direction,
				'sort_by': this.order,
				's': jQuery('#search_filters input[name="s"]').val(),
				'post_types': $('#post_types').val(),
				// 'query': ajaxObject.posts, // loop parameters passed by wp_localize_script()
				'page' : ajaxObject.current_page // current page
			},
			type : 'POST',
			beforeSend : function(){
				$('#posts_wrap').addClass('opacity-40', 'pointer-events-none');
			},
			success : function( response ){

				if( response.html.length ) {
					$('#posts_wrap').removeClass('opacity-40', 'pointer-events-none');
					
					$('#posts_wrap').html( response.html ); // insert new posts
				} 

				ajaxObject.current_page = response.current_page;

				$('.js-start').text(response.from_page);
				if (response.to_page > response.total_posts){
					$('.js-end').text(response.total_posts);
				} else {
					$('.js-end').text(response.to_page);
				}
				$('.js-total').text(response.total_posts);
				$('.js-paged').text(response.current_page);
				$('.js-max-pages').text(response.max_page);
			}
		});

    }

    // filter() {

	// 	var data = {
    //         'sort_by': $('#sort_by').val(),
    //         'post_types': $('#post_types').val(),
	// 		'action': 'searchfilter',
    //     };

    //     $.ajax({
	// 		url : ajaxObject.ajax_url,
	// 		data : data,
	// 		dataType : 'json',
	// 		type : 'POST',
	// 		beforeSend : function(){
	// 			$('#posts_wrap').addClass('opacity-40', 'pointer-events-none');
	// 		},
	// 		success : function( data ){

	// 			$('#posts_wrap').removeClass('opacity-40', 'pointer-events-none');

	// 			// when filter applied:
	// 			// set the current page to 1
	// 			ajaxObject.current_page = 1;

	// 			// set the new query parameters
	// 			ajaxObject.posts = data.posts;

	// 			// set the new max page parameter
	// 			ajaxObject.max_page = data.max_page;

	// 			// insert the posts to the container
	// 			$('#posts_wrap').html(data.content);

	// 			// hide load more button, if there are not enough posts for the second page
	// 			if ( data.max_page < 2 ) {
	// 				$('.js-next-page').hide();
	// 			} else {
	// 				$('.js-next-page').show();
	// 			}
	// 		}
	// 	});

	// 	// do not submit the form
	// 	return false;
    // }
}
